import MuiDivider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';

const Divider = styled(MuiDivider, { name: 'Divider', slot: 'Root' })(
  ({ theme }) => ({
    borderColor: theme.palette.divider,
  })
);
export default Divider;
